module.exports = __webpack_public_path__ + "static/media/NewZealand.651e597a.jpg";